import { useNavigate } from "react-router-dom";
import { useReveal } from "../hooks/useReveal";
import "./Services.css";

export default function Services({ data }) {
  const nav = useNavigate();
  const go = (page) => nav(page === "home" ? "/" : `/${page}`);

  return (
    <div className="sv">

      {/* HERO */}
      <section className="sv-hero">
        <div className="sv-hero-inner wrap">
          <div>
            <span className="sv-tag-top">{data?.hero?.tag}</span>
            <h1 className="sv-hero-h1">
              {data?.hero?.h1?.map((line, i) => (
                <span
                  key={i}
                  className={line === data?.hero?.italic ? "italic" : ""}
                >
                  {line}
                  <br />
                </span>
              ))}
            </h1>
          </div>

          <div>
            <div className="sv-hero-line" />
            <p className="sv-hero-p">{data?.hero?.body}</p>
            <button className="btn btn-r" onClick={() => go("contact")}>
              Initiate a Mandate
            </button>
          </div>
        </div>
      </section>

      {/* SERVICES LIST */}
      <section className="sv-list">
        {data?.items?.map((item, idx) => {
          const revealRef = useReveal();

          return (
            <div
              className={`sv-item${idx % 2 === 1 ? " even" : ""}`}
              key={item.num}
              ref={revealRef}
            >
              <div className="sv-txt">
                <div className="sv-bar" />
                <h2 className="sv-h2">{item.title}</h2>
                <p className="sv-p">{item.body}</p>

                <ul className="sv-includes-list">
                  {item.includes?.map((inc) => (
                    <li key={inc}>
                      <span>›</span>
                      {inc}
                    </li>
                  ))}
                </ul>

                {/* PROCESS FLOW */}
                {item.process && (
                  <>
                    <div className="sv-divider" />
                    <div className="sv-process-hd">Our Process Flow</div>

                    {item.process.map((p) => (
                      <div className="sv-process-item" key={p.step}>
                        <div className="sv-process-step">{p.step}</div>
                        <div className="sv-process-body">
                          <strong>{p.title}</strong>
                          <p>{p.body}</p>
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {/* WHO WE WORK WITH */}
                {item.developers && (
                  <>
                    <div className="sv-divider" />

                    <span className="sv-dev-tag">
                      {item.developers.tag}
                    </span>

                    <h3 className="sv-dev-h3">
                      {item.developers.h2}
                    </h3>

                    <p className="sv-p">{item.developers.body}</p>

                    <div className="sv-meta-block">
                      <span className="sv-meta-label">Ticket Sizes</span>
                      <div className="sv-meta-value red">
                        {item.developers.ticketSizes}
                      </div>
                    </div>

                    <div className="sv-meta-block">
                      <span className="sv-meta-label">Active Cities</span>
                      <div className="sv-city-pills">
                        {item.developers.cities.map((c) => (
                          <span className="sv-pill" key={c}>
                            {c}
                          </span>
                        ))}
                      </div>
                    </div>
                  </>
                )}

                <button className="btn btn-o" onClick={() => go("contact")}>
                  Enquire →
                </button>
              </div>

              <div className="sv-img">
                <img src={item.image} alt={item.title} loading="lazy" />
                <div className="sv-img-num">{item.num}</div>
              </div>
            </div>
          );
        })}
      </section>

    </div>
  );
}